export default "__VITE_ASSET__9fc1552e__"